import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useColor } from "utils/colors"

const useBoardBackgroundStyle = (id) => {
  const background = useSelector<any, any>(state => state['view-board'].settings[id]?.background)

  const backgroundImageUrl = useSelector<any, string | undefined>(state => state.kanbo.branding.imageSets.byId[state['view-board'].settings[id]?.background?.image]?.images['background4k'])

  const backgroundColor = useColor(background?.type === 'color' ? background.color : undefined)

  return useMemo(() => {
    if (background) {
      if (background.type === 'color') {
        return {
          backgroundColor,
        }
      } else if (background.type === 'image') {
        return {
          backgroundImage: `url(${backgroundImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }
      }
    }

    return undefined
  }, [background, backgroundColor, backgroundImageUrl])
}

export default useBoardBackgroundStyle